import {IMiniOrbitCommunicationAdapterFactoryService} from './mini-orbit-communication-adapter-factory.service.interface';
import {IMiniOrbitCommunicationAdapter} from '../adapters/mini-orbit-communication-adapter.interface';
import {PokerCommunicationAdapter} from '../adapters/poker/poker-communication-adapter';
import {ServiceBase} from '../../ServiceBase';
import {VoidCommunicationAdapter} from '../adapters/void/void-communication-adapter';
import {MINI_CIP_BASE_ROUTE} from '../mini-orbit-consts';

export class MiniOrbitCommunicationAdapterFactoryService extends ServiceBase implements IMiniOrbitCommunicationAdapterFactoryService{
    createAdapter(basePath: string): IMiniOrbitCommunicationAdapter {
        switch(basePath?.toLowerCase()) {
            case MINI_CIP_BASE_ROUTE:
                return new PokerCommunicationAdapter(this.services);
            default:
                return new VoidCommunicationAdapter(this.services);
        }
    }
}